<template>
  <virtual-selector
    :isLoading="loading"
    :placeholder="placeholder"
    v-model="defaultValue"
    :name.sync="defaultName"
    :optionList="optionList"
    :readonly="readonly"
    filterable
    remote
    :option="{
      label: 'Name',
      key: 'KeyNo',
    }"
    :size="size"
    :remoteMethod="handleSearch"
    :load-more="loadMore"
    @change="handleChange">
  </virtual-selector>
</template>
<script>
import VirtualSelector from '@/components/common/virtualSelector';
import axios from 'axios';
import { getEnterprisePage } from '@/api/commonForm.js';
export default {
  name: 'COMMON_ENTERPRISE',
  components: {
    VirtualSelector,
  },
  props: {
    value: {
      type: String,
    },
    size: {
      type: String,
      default: 'small',
    },
    name: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default () {
        return '请选择企业';
      },
    },
  },
  data () {
    return {
      optionList: [],
      loading: false,
      defaultValue: this.value,
      defaultName: this.name,
      pageIndex: 1,
      isReachLast: false,
    };
  },
  watch: {
    value () {
      this.defaultValue = this.value;
    },
    name () {
      this.defaultName = this.name;
    },
  },
  methods: {
    handleChange (item) {
      this.$emit('input', item?.KeyNo);
      this.$emit('update:name', item?.Name);
      this.$emit('change', item || {});
    },
    handleSearch (name) {
      this.pageIndex = 1;
      this.isReachLast = false;
      this.optionList.splice(0, this.optionList.length);
      this.getList(name);
    },
    loadMore (keyword) {
      if (!this.isReachLast) {
        this.pageIndex += 1;
        this.getList(keyword);
      }
    },
    getList (keyword = '') {
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel();
      }
      const cancelToken = axios.CancelToken;
      this.cancelTokenSource = cancelToken.source();
      this.loading = true;
      getEnterprisePage({
        keyWord: keyword,
        pageNum: this.pageIndex,
        pageSize: 10,
      }, {
        stopDefaultLoading: true,
        cancelToken: this.cancelTokenSource.token,
      })
        .then(res => {
          this.isReachLast = (res.body?.length || 0) < 10;
          this.optionList = this.optionList.concat(res.body || []);
          this.loading = false;
        })
        .catch((res) => {
          if (res?.heads?.code !== -100) {
            this.loading = false;
          }
        });
    },
  },
};
</script>
